<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useDateHelper } from "@/composables/useDateHelper";
  import { useSpotStore } from "@/stores/SpotStore";

  const dateHelper = useDateHelper();

  const spotStore = useSpotStore();

  const { t } = useI18n();

  const apiData = computed(() => spotStore.stationApiDataValues);
  
  const timestamp = computed(() => {
    if (!apiData.value.timestamp) return 'N/A';

    let apiTimestamp;
    let relativeTimestamp = 'N/A';

    try {
      apiTimestamp = dateHelper.datetimeToISOFormat(apiData.value.timestamp, spotStore.localUTCOffset);
      relativeTimestamp =  dateHelper.timeFromNow(apiTimestamp);
    } catch (e) {
      console.warn('Error parsing api timestamp: ', apiData.value.timestamp, e);
    }

    return relativeTimestamp
  });
</script> 

<template>
    <p class="jwx-current-conditions-last-update"><span class="jwx-current-conditions-last-update__label">{{ t('common.lastUpdate') }}</span> <span v-html="timestamp" class="jwx-current-conditions-last-update__timestamp"></span></p>
</template>